import type { SxProps, Theme } from '@mui/material';
import { Box, Typography, useMediaQuery } from '@mui/material';

import { boxStyles, envTitle, shouldShowEnvLabel } from '../utils';
import MobileSection from './MobileSection';
import Profile from './Profile';

// ==============================|| HEADER - CONTENT ||============================== //
const HeaderContent = () => {
    const matchesXs = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

    return (
        <Box sx={boxStyles as SxProps}>
            {shouldShowEnvLabel && <Typography>{envTitle}</Typography>}
            <Box>
                {!matchesXs && <Profile />}
                {matchesXs && <MobileSection />}
            </Box>
        </Box>
    );
};

export default HeaderContent;
